import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services';

@Pipe({ name: 'formatNumber', pure: true, standalone: true })
export class FormatNumberPipe implements PipeTransform {
    constructor(private currencyService: CurrencyService) {}

    transform(value: number | string | null | undefined): string {
        return this.currencyService.formatNumber(value);
    }
}
